import React, { Component } from 'react'
import './Loading.scss'
import { Vimoneloding, LoadingWrap, Container, LoadingText, FlexloadingText } from './Loading.style'
import i18n from '../../i18n'
import {connect} from 'react-redux';
class Loading extends Component {
    render() {
        const {background , fixEllipsisStyle} = this.props;
        return (
            <LoadingWrap background = {background}>
                <Container>
                    <FlexloadingText>
                        <div className={ `${fixEllipsisStyle ? "fixEllipsisStyle" : "" } loading-component-name`}>{this.props.componentName}</div>
                        <div className={`lds-ellipsis-loading ${fixEllipsisStyle ? "fixEllipsisStyle" : ""}`}><div></div><div></div><div></div><div></div></div>
                    </FlexloadingText>
                </Container>
            </LoadingWrap>
        );
    }
}
const mapStateToProps = state => ({
    theme: state.themeStore.theme
})
export default connect(mapStateToProps,null)(Loading)
